import { Box, Flex,  Heading, HStack, Icon, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { LuCircleGauge, LuShieldCheck } from 'react-icons/lu'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

const InfoSection = () => {

    const cardColor = useColorModeValue('white', 'gray.900')
    const {t} = useTranslation()
    const MotionBox = motion.create(Box)


    const ArrayofAdventage = [
        {
            title : t('featureChild1TitleServiceOne'),
            subtitle : t('featureChild1BrandServiceOne'),
            description : t('featureChild1DescriptionServiceOne'),
            icon: <LuShieldCheck/>,
            color: 'blue',
            bgColor: useColorModeValue('blue.100', 'blue.900'),
        },
        {
            title : t('featureChild2TitleServiceOne'),
            subtitle : t('featureChild2BrandServiceOne'),
            description : t('featureChild2DescriptionServiceOne'),
            icon: <LuCircleGauge/>,
            color: 'green',
            bgColor: useColorModeValue('green.100', 'green.900'),
        },
        {
            title : t('featureChild3TitleServiceOne'),
            subtitle : t('featureChild3BrandServiceOne'),
            description : t('featureChild3DescriptionServiceOne'),
            icon: <LuCircleGauge/>,
            color: 'purple',
            bgColor: useColorModeValue('purple.100', 'purple.900'),
        }
    ]

    
  return (
    <Flex
        px={{md: 'inherit', '2xl': "19%", base: 4}}
        py={{'2xl' :20, base: 12}}
        overflow={'hidden'}
        position={'relative'}
    >
        <Box w={'full'} id='info-section'>
            <Flex justify={'center'}> 
                <Heading maxW={'450px'}  textAlign={'center'} fontFamily={'Poppins'} letterSpacing={-1.5} lineHeight={1.1} fontSize={{ md: '4xl', '2xl': '5xl', base: '2xl' }} >
                    {t('featureTitleServiceOne')}
                </Heading>
            </Flex>



            <Flex mt={{md: 20, base: 14}} flexDir={{md: 'row', base: 'column'}} justify={'center'} align={{md: "start", base: "center" }} w={'full'} gap={{md: 20, base: 8}}>

                {
                    ArrayofAdventage.map((elt, index)=>

                        <MotionBox
                        whileHover={{ rotate: -10 }}
                         key={index} boxShadow={'md'} overflow={'hidden'} w={'350px'} minH={'360px'} rounded={24} position={'relative'} bgColor={cardColor} p={10}>
                            <Box 
                                position={'absolute'}
                                left={-10}
                                zIndex={0}
                                rounded={'full'}
                                boxSize={'130px'}
                                filter={'blur(20px)'}
                                bgColor={elt.bgColor}
                            />

                            <Box 
                                position={'absolute'}
                                top={40}
                                zIndex={0}
                                right={-10}
                                rounded={'full'}
                                boxSize={'130px'}
                                filter={'blur(20px)'}
                                bgColor={elt.bgColor}
                            />

                            <HStack position={'relative'}>
                                <Box p={2} bgColor={`${elt.color}.600`} rounded={'full'}>
                                    <Icon color={'white'} boxSize={6}>
                                        <LuShieldCheck/>
                                    </Icon>
                                </Box>
                                <Heading fontFamily={'Onest'} letterSpacing={-1.2}>
                                    {elt.title}
                                </Heading>
                            </HStack>

                            <Box mt={10} fontSize={''} position={'relative'}>
                                <Text fontFamily={'Outfit'} fontWeight={500}>
                                    {elt.subtitle}
                                </Text>
                                <Text mt={4}>
                                    {elt.description}
                                </Text>
                            </Box>
                        </MotionBox>
                    )
                }
            </Flex>

        </Box>
    </Flex>
  )
}

export default InfoSection